import React from 'react';
import { Settings, Info, Github, ExternalLink } from 'lucide-react';

const SettingsPanel = () => {
  return (
    <div className="h-full flex flex-col bg-white">
      {/* Header */}
      <div className="border-b border-gray-200 p-6">
        <div>
          <h2 className="text-xl font-semibold text-gray-800">Settings</h2>
          <p className="text-sm text-gray-500 mt-1">
            Configuration and information
          </p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        {/* About */}
        <div className="p-4 bg-gray-50 rounded-lg border">
          <div className="flex items-center gap-2 mb-3">
            <Info className="w-5 h-5 text-blue-600" />
            <h3 className="font-medium text-gray-800">About MCP Playground</h3>
          </div>
          <p className="text-sm text-gray-600 mb-3">
            A comprehensive playground for integrating and testing Model Context Protocol (MCP) servers. 
            Built with React and Tailwind CSS.
          </p>
          <div className="text-xs text-gray-500 space-y-1">
            <p>Version: 1.0.0</p>
            <p>Protocol: MCP 2024-11-05</p>
            <p>Built with: React 18, Tailwind CSS, Node.js</p>
          </div>
        </div>

        {/* Features */}
        <div className="p-4 bg-gray-50 rounded-lg border">
          <h3 className="font-medium text-gray-800 mb-3">Features</h3>
          <ul className="text-sm text-gray-600 space-y-2">
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
              Server Management - Connect and manage multiple MCP servers
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
              Tool Explorer - Discover and test available tools
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
              Chat Interface - Natural language command processing
            </li>
            <li className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
              Real-time Communication - WebSocket-based updates
            </li>
          </ul>
        </div>

        {/* Commands */}
        <div className="p-4 bg-gray-50 rounded-lg border">
          <h3 className="font-medium text-gray-800 mb-3">Chat Commands</h3>
          <div className="text-sm text-gray-600 space-y-2">
            <div>
              <code className="bg-gray-200 px-2 py-1 rounded text-xs">add [num] + [num]</code>
              <span className="ml-2">Add two numbers</span>
            </div>
            <div>
              <code className="bg-gray-200 px-2 py-1 rounded text-xs">echo [text]</code>
              <span className="ml-2">Echo back text</span>
            </div>
            <div>
              <code className="bg-gray-200 px-2 py-1 rounded text-xs">time</code>
              <span className="ml-2">Get current timestamp</span>
            </div>
            <div>
              <code className="bg-gray-200 px-2 py-1 rounded text-xs">help</code>
              <span className="ml-2">Show available commands</span>
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="p-4 bg-gray-50 rounded-lg border">
          <h3 className="font-medium text-gray-800 mb-3">Resources</h3>
          <div className="space-y-2">
            <a
              href="https://github.com/modelcontextprotocol"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800"
            >
              <Github className="w-4 h-4" />
              Model Context Protocol
              <ExternalLink className="w-3 h-3" />
            </a>
            <a
              href="https://react.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800"
            >
              <ExternalLink className="w-4 h-4" />
              React Documentation
              <ExternalLink className="w-3 h-3" />
            </a>
            <a
              href="https://tailwindcss.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800"
            >
              <ExternalLink className="w-4 h-4" />
              Tailwind CSS
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;